import _ from "lodash"

import CONFIG from "configuration/environment"

// 1 week
const DEFAULT_EXPIRE = 604800000

// local storage key prefix
const LOCAL_STORAGE_PREFIX = `${CONFIG.REACT_APP_ROOT_DIV_ID}.`

// If state timeout is not defined as config variable, we will initialize to 1 week
export const reduxStateExpire = CONFIG.REACT_APP_LOCALSTORE_REDUX_STATE_EXPIRE
  ? CONFIG.REACT_APP_LOCALSTORE_REDUX_STATE_EXPIRE
  : DEFAULT_EXPIRE

// Object with the specific expiration period of each key stored in local storage
const keysWithSpecificExpirationPeriod = {
  "user-token": 0,
  "redux-state": reduxStateExpire
}

// Get expiration period for a key, if not defined it defaults to DEFAULT_EXPIRE
const getExpirationPeriod = key => {
  const expirationPeriod = keysWithSpecificExpirationPeriod[key]
    ? keysWithSpecificExpirationPeriod[key]
    : DEFAULT_EXPIRE
  return expirationPeriod
}

// Check if a object in local storage is expired
const isExpired = key => {
  if (typeof Storage !== "undefined") {
    const currentTime = Date.now()
    try {
      const item = JSON.parse(localStorage.getItem(`${LOCAL_STORAGE_PREFIX}${key}`))
      if (item && currentTime > item.expiresOn) {
        return true
      }
    } catch (error) {
      removeFromLocalStorage(key)
    }
  }
  return false
}

// Function to decode the user token
const decodeUserToken = token => {
  const [, payloadBase64] = token.split(".")
  const payload = JSON.parse(atob(payloadBase64))
  return payload
}

/*
  Save data into localStorage as key / value pairs.
*/
// Get a single key from local storage
// return: item if it exists into localstorage and is not expired
export const getFromLocalStorage = key => {
  if (typeof Storage !== "undefined") {
    if (isExpired(key)) {
      // token is in local storage but it is expired
      removeFromLocalStorage(key)
    } else {
      try {
        return JSON.parse(localStorage.getItem(`${LOCAL_STORAGE_PREFIX}${key}`)) || null
      } catch (error) {
        removeFromLocalStorage(key)
      }
    }
  }
  return null
}

// Set a single key in local storage
export const setInLocalStorage = (key, value) => {
  if (typeof Storage !== "undefined") {
    let expiresOn = Date.now() + getExpirationPeriod(key)

    if (key === "user-token") {
      const { exp } = decodeUserToken(value)
      expiresOn = exp * 1000 // set new expiration returned from API in milliseconds.
      localStorage.setItem(`${LOCAL_STORAGE_PREFIX}${key}`, JSON.stringify({ value, expiresOn }))
    }

    // Create a new locally stored item
    else localStorage.setItem(`${LOCAL_STORAGE_PREFIX}${key}`, JSON.stringify({ value, expiresOn }))
  }
}

// Remove a single key from local storage
export const removeFromLocalStorage = key => {
  if (typeof Storage !== "undefined") {
    const item = localStorage.getItem(`${LOCAL_STORAGE_PREFIX}${key}`)

    if (item) {
      localStorage.removeItem(`${LOCAL_STORAGE_PREFIX}${key}`)
    }
  }
}

// check and remove all expired keys in localStore
export const checkLocalStorageExpiredKeys = () => {
  if (typeof Storage !== "undefined") {
    _.forEach(Object.keys(localStorage), key => {
      if (_.startsWith(key, LOCAL_STORAGE_PREFIX)) {
        // this method already removes expired keys
        getFromLocalStorage(_.replace(key, LOCAL_STORAGE_PREFIX, ""))
      }
    })
  }
}
